<template>
  <div>
    <PageHeader :title="nameTitle" :items="headerItems" />
    <div style="border-radius: 5px; background-color: white; padding: 20px">
      <div class="d-flex align-items-center mb-3 p-0">
        <div class="d-flex align-items-center">
          <span class="sectionTitle">اطلاعات پستی</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="section">
        <b-row class="mb-3">
          <b-col cols="6">
            <div v-if="forceUpdateFlag">
              <ComboBox
                title="استان"
                placeholder="استان"
                @selectedItem="selectedProvince($event)"
                @searchedItem="searchedProvince($event)"
                :searchedData="searchedProvinceData"
                @input="selectProvince = $event"
                :selectedValue="selectProvince"
              />
            </div>
          </b-col>
          <b-col cols="6">
            <div v-if="resetCityFlag">
              <ComboBox
                title="شهر"
                placeholder="شهر"
                @selectedItem="selectedCity($event)"
                @searchedItem="searchedCity($event)"
                :searchedData="searchedCityData"
                @input="selectCity = $event"
                :selectedValue="selectCity"
                :disabled="cityDisabled"
              />
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12">
            <TextAreaInput @input="formData.address.addressText = $event" title="آدرس" placeholder="آدرس" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <BaseText inputType="number" :maxlength="10" @input="formData.address.postalCode = $event" title="کد پستی" placeholder="کد پستی" />
          </b-col>
        </b-row>
      </div>
      <div>
        <div class="buttonClass">
          <Button @click.native="submit" btnClass="submitButton" text="ثبت" :loading="disableSubmit" />
          <b-button @click="$bvModal.show('cancleModal')" class="cancleButton">
            <span class="cancleTitle">انصراف</span>
          </b-button>
          <b-modal id="cancleModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
            <div class="error-wrapper">
              <div class="mb-4">
                <img src="@/assets/images/checked1.svg" />
              </div>
              <div class="error-title">آیا از انصراف خود مطمئن هستید؟</div>
              <div class="buttons">
                <div @click="$bvModal.hide('cancleModal')">
                  <button class="cancelButton">خیر</button>
                </div>
                <div @click="goBack()">
                  <button class="approveButton">بلی</button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
        <Toast title="اطلاعات با موفقیت ذخیره شد" :showToast="submitAlert" />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import BaseText from '../common/form/formModules/BaseText.vue'
import TextAreaInput from '../common/form/formModules/TextAreaInput.vue'
import ComboBox from '../common/form/formModules/ComboBox.vue'
import invoiceDataProvider from '../../services/invoice'
import { invoiceMixins, userMixins } from '../../utils/mixins'
import Toast from '../common/Toast.vue'
import Button from '../common/Button.vue'
import userDataProvider from '../../services/user'

export default {
  name: 'add-address',
  components: {
    PageHeader,
    BaseText,
    TextAreaInput,
    ComboBox,
    Toast,
    Button,
  },
  mixins: [invoiceMixins, userMixins],

  data() {
    return {
      forceUpdateFlag: true,
      resetCityFlag: true,
      disableSubmit: false,
      searchedProvinceData: [],
      submitAlert: false,
      searchedCityData: [],
      selectProvince: '',
      selectCity: '',
      cityDisabled: true,
      formData: {
        address: {
          cityId: 0,
          addressText: null,
          postalCode: null,
        },
      },
    }
  },
  computed: {
    nameTitle() {
      return 'مدیریت آدرس'
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.nameTitle,
          active: true,
        },
      ]
    },
  },
  methods: {
    submit() {
      userDataProvider
        .addAddress({
          userId: this.selectedCustomer.key,
          cityId: this.formData.address.cityId,
          provinceId: this.provinceId,
          postalCode: this.formData.address.postalCode,
          postalAddress: this.formData.address.addressText,
        })
        .then((res) => {
          this.submitAlert = true
          setTimeout(() => {
            this.submitAlert = false
            this.goBack()
          }, 3000)
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    selectedProvince(event) {
      this.provinceId = event.key
      this.resetCityFlag = false
      this.$nextTick(() => {
        this.resetCityFlag = true
      })
      invoiceDataProvider
        .getCity({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
          ProvinceId: event.key,
        })
        .then((res) => {
          this.$store.dispatch('invoice/setCityData', res.data.data)
          this.searchedCityData = this.cityData
          this.cityDisabled = false
        })
    },
    searchedProvince(event) {
      this.searchedProvinceData = this.provinceData
      this.searchedProvinceData = this.provinceData.filter((item) => {
        return item.value.includes(event)
      })
    },
    selectedCity(event) {
      this.formData.address.cityId = event.key
    },
    searchedCity(event) {
      this.searchedCityData = this.cityData
      this.searchedCityData = this.cityData.filter((item) => {
        return item.value.includes(event)
      })
    },
  },
  beforeMount() {
    this.forceUpdateFlag = false
    this.$nextTick(() => {
      invoiceDataProvider
        .getProvince({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
        })
        .then((res) => {
          this.$store.dispatch('invoice/setProvinceData', res.data.data)
          this.searchedProvinceData = this.provinceData
        })
      this.forceUpdateFlag = true
    })
  },
}
</script>

<style scoped lang="scss">
::v-deep .alert {
  padding: 0 !important;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.submitButton {
  font-size: 14px !important;
  padding: 8px 45px !important;
  color: white !important;
  background: #556ee6 !important;
  border: 1px solid #556ee6 !important;
  box-sizing: border-box !important;
  border-radius: 4px !important;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
</style>
